import { render, staticRenderFns } from "./CurrencyLogo.vue?vue&type=template&id=0f45c8a7"
import script from "./CurrencyLogo.vue?vue&type=script&lang=js"
export * from "./CurrencyLogo.vue?vue&type=script&lang=js"
import style0 from "./CurrencyLogo.vue?vue&type=style&index=0&id=0f45c8a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports